import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import { UrlService } from '../../services/url.service';

declare const moment: any;

@Component({
    selector: 'stripe-accounts-filter',
    templateUrl: './stripe-accounts-filter.component.html',
    styleUrls: ['./stripe-accounts-filter.component.scss']
})
export class StripeAccountsFilterComponent implements OnInit {
    showDropdown = false;
    startDate = '';
    endDate = '';
    @ViewChild('startDateCheckbox') startDateCheckbox: ElementRef;
    @ViewChild('endDateCheckbox') endDateCheckbox: ElementRef;

    hasPayout;

    constructor(
        private urlService: UrlService
    ) { }

    ngOnInit() {
        this.setFilterData();
    }

    onFilterChange() {
        this.urlService.queryParams['hasPayout'] = this.hasPayout ? '1' : '0';
        this.urlService.queryParams['periodStartDate'] = this.startDate ? moment(this.startDate).format('YYYY-MM-DD') : null;
        this.urlService.queryParams['periodEndDate'] = this.endDate ? moment(this.endDate).add(1, 'day').format('YYYY-MM-DD') : null;

        this.urlService.setQueryParams(null, 1);
    }

    onStartDateChange() {
        if(this.startDate > this.endDate) {
            this.endDate = '';
            this.urlService.queryParams['periodEndDate'] = null;
        }
    }

    clearDates() {
        this.startDate = '';
        this.endDate = '';
        this.onFilterChange();
    }

    setFilterData() {
        this.hasPayout = !!+this.urlService.queryParams['hasPayout'];
        const periodStartDate = this.urlService.queryParams['periodStartDate'];
        const periodEndDate = this.urlService.queryParams['periodEndDate'];

        if(periodStartDate) {
            this.startDate = moment(periodStartDate)._d;
        }

        if(periodEndDate) {
            this.endDate = moment(periodEndDate).add(-1, 'day')._d;
        }
    }

    @HostListener('document:click', ['$event.target'])
    hideDropdown(targetElement: HTMLElement): void {
        if (!targetElement.closest('stripe-accounts-filter') &&
            !targetElement.closest('.cdk-overlay-container') &&
            !targetElement.closest('.mat-calendar-body-cell-content'))
            this.showDropdown = false;
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/stripe-accounts-filter/stripe-accounts-filter.component.ts